import Vue from 'vue'
import App from './App.vue'
import router from './router'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faWhatsapp, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons'


import { 
  faVolumeXmark,
  faEnvelope,
  faXmark,
  faVolumeHigh
} from "@fortawesome/free-solid-svg-icons";
/* add icons to the library */
library.add(faWhatsapp, faLinkedin, faInstagram, faVolumeXmark, faVolumeHigh, faEnvelope, faXmark)



/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
